import { v4 as uuidv4 } from 'uuid';

const dataSilder = [
    {
        id: uuidv4(),
        titulo: "Tinogasta - Seismiles (3 días)",
        subtitulo: "Pedaléa entre las montañas de más de 6000 metros",
        ubicacion: "Tinogasta, Provincia de Catamarca",
        alquiler: "uno",
        carpeta: "tinogasta",
        imagenes:9,
        testimonios:[
            {nombre:"Juan", mensaje:"Excelente lugar para descansar en familia. Muy recomendable.",imagen: "testimonio-uno-uno.jpg"},
            {nombre:"Maria", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-dos.jpg"},
            {nombre:"Pedro", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-tres.jpg"},
            {nombre:"Romina", mensaje:"Super cómodo y tranquilo.",imagen: "testimonio-uno-dos.jpg"}],
        precio: 380000,
        capacidad: 3,
        servicios: [
            { nombre: "Wi-Fi", icono: "wifi", mensaje: "NO" },
            { nombre: "Aire acondicionado", icono: "aire-acondicionado", mensaje: "x1" },
            { nombre: "Calefacción", icono: "calefaccion", mensaje: "2 caloventores" },
            { nombre: "Baños", icono: "baño", mensaje:"x1" },
            { nombre: "Cocina", icono: "cocina", mensaje:"x1" },
            { nombre: "Lavarropas", icono: "lavarropas", mensaje:"NO" },
            { nombre: "Secador Pelo", icono: "secador-pelo", mensaje:"NO" },
            { nombre: "Frazadas", icono: "frazadas", mensaje:"Si" },
            { nombre: "Ropa Blanca", icono: "ropadecama", mensaje:"NO" },
            { nombre: "Pet Friendly", icono: "pets", mensaje:"Si" },
            { nombre: "Cochera", icono: "cochera", mensaje:"x1" }
        ],
        dormitorios: [
            { nombre: "Individuales", icono: "cama1", mensaje: "x2" },
            { nombre: "Dobles", icono: "cama-doble", mensaje: "x1" }
        ],
        instalaciones: [
            { nombre: "Jardín", icono: "cochera", mensaje:"x2" },
            { nombre: "Asador", icono: "parrilla", mensaje:"x2" },
            { nombre: "Vista Panoramica", icono: "vista-panoramica", mensaje:"x2" }
        ]
    },
    {
        id: uuidv4(),
        titulo: "La Cumbrecita (2 días)",
        subtitulo: "Encanto serrano y naturaleza viva",
        ubicacion: "La Cumbrecita - Córdoba",
        alquiler: "dos",
        carpeta: "cumbrecita",
        imagenes:5,
        testimonios:[{nombre:"Juan", mensaje:"Excelente lugar para descansar en familia. Muy recomendable.",imagen: "testimonio-uno-uno.jpg"},
        {nombre:"Maria", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-dos.jpg"},
        {nombre:"Pedro", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-tres.jpg"},
        {nombre:"Romina", mensaje:"Super cómodo y tranquilo.",imagen: "testimonio-uno-uno.jpg"}],
        precio: 180000,
        capacidad: 3,
        servicios: [
            { nombre: "Wi-Fi", icono: "wifi", mensaje: "" },
            { nombre: "Aire acondicionado", icono: "aire-acondicionado", mensaje: "x1" },
            { nombre: "Calefacción", icono: "calefaccion", mensaje: "x1" },
            { nombre: "Baños", icono: "baño", mensaje:"x1" },
            { nombre: "Cocina", icono: "cocina", mensaje:"x1" },
            { nombre: "Lavarropas", icono: "lavarropas", mensaje:"Si" },
            { nombre: "Frazadas", icono: "frazadas", mensaje:"Si" },
            { nombre: "Ropa Blanca", icono: "ropadecama", mensaje:"No" },
            { nombre: "Pet Friendly", icono: "pets", mensaje:"Si" },
            { nombre: "Cochera", icono: "cochera", mensaje:"x1" }
        ],
        dormitorios: [
            { nombre: "Individuales", icono: "cama1", mensaje: "x2" },
            { nombre: "Dobles", icono: "cama-doble", mensaje: "x2" }
        ],
        instalaciones: [
            { nombre: "Jardín", icono: "cochera", mensaje:"x2" },
            { nombre: "Asador", icono: "parrilla", mensaje:"x2" }
        ]
    },

    {
        id: uuidv4(),
        titulo: "Los Reartes",
        subtitulo: "Tradición y río cristalino",
        ubicacion: "Los Reartes - Córdoba",
        alquiler: "tres",
        carpeta: "reartes",
        imagenes:8,
        testimonios:[{nombre:"Juan", mensaje:"Excelente lugar para descansar en familia. Muy recomendable.",imagen: "testimonio-uno-uno.jpg"},
            {nombre:"Maria", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-dos.jpg"},
            {nombre:"Pedro", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-tres.jpg"},
            {nombre:"Romina", mensaje:"Super cómodo y tranquilo.",imagen: "testimonio-uno-uno.jpg"}],
        precio: 150000,
        capacidad: 3,
        servicios: [
            { nombre: "Wi-Fi", icono: "wifi", mensaje: "" },
            { nombre: "Aire acondicionado", icono: "aire-acondicionado", mensaje: "x1" },
            { nombre: "Calefacción", icono: "calefaccion", mensaje: "x1" },
            { nombre: "Baños", icono: "baño", mensaje:"x1" },
            { nombre: "Cocina", icono: "cocina", mensaje:"x1" },
            { nombre: "Lavarropas", icono: "lavarropas", mensaje:"Si" },
            { nombre: "Frazadas", icono: "frazadas", mensaje:"Si" },
            { nombre: "Ropa Blanca", icono: "ropadecama", mensaje:"No" },
            { nombre: "Pet Friendly", icono: "pets", mensaje:"Si" },
            { nombre: "Cochera", icono: "cochera", mensaje:"x1" }
        ],
        dormitorios: [
            { nombre: "Individuales", icono: "cama1", mensaje: "x3" },
            { nombre: "Dobles", icono: "cama-doble", mensaje: "x1" }
        ],
        instalaciones: [
            { nombre: "Jardín", icono: "cochera", mensaje:"x2" },
            { nombre: "Asador", icono: "parrilla", mensaje:"x2" }
        ]
    },

    {
        id: uuidv4(),
        titulo: "Puentes de Copina",
        subtitulo: "Desafío y vistas panorámicas",
        ubicacion: "Copina - Córdoba",
        alquiler: "cuatro",
        carpeta: "copina",
        imagenes:8,
        testimonios:[{nombre:"Juan", mensaje:"Excelente lugar para descansar en familia. Muy recomendable.",imagen: "testimonio-uno-uno.jpg"},
            {nombre:"Maria", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-dos.jpg"},
            {nombre:"Pedro", mensaje:"Un lugar muy tranquilo y con una vista increíble.",imagen: "testimonio-uno-tres.jpg"},
            {nombre:"Romina", mensaje:"Super cómodo y tranquilo.",imagen: "testimonio-uno-uno.jpg"}],
        precio: 130000,
        capacidad: 3,
        servicios: [
            { nombre: "Wi-Fi", icono: "wifi", mensaje: "" },
            { nombre: "Aire acondicionado", icono: "aire-acondicionado", mensaje: "x1" },
            { nombre: "Calefacción", icono: "calefaccion", mensaje: "x1" },
            { nombre: "Baños", icono: "baño", mensaje:"x1" },
            { nombre: "Cocina", icono: "cocina", mensaje:"x1" },
            { nombre: "Lavarropas", icono: "lavarropas", mensaje:"Si" },
            { nombre: "Frazadas", icono: "frazadas", mensaje:"Si" },
            { nombre: "Ropa Blanca", icono: "ropadecama", mensaje:"No" },
            { nombre: "Pet Friendly", icono: "pets", mensaje:"Si" },
            { nombre: "Cochera", icono: "cochera", mensaje:"x1" }
        ],
        dormitorios: [
            { nombre: "Individuales", icono: "cama1", mensaje: "x3" },
            { nombre: "Dobles", icono: "cama-doble", mensaje: "x1" }
        ],
        instalaciones: [
            { nombre: "Jardín", icono: "cochera", mensaje:"x2" },
            { nombre: "Asador", icono: "parrilla", mensaje:"x2" }
        ]
    }
]

export default dataSilder;


/*
        servicios: [
            { nombre: "Wi-Fi", icono: "wifi", mensaje: "" },
            { nombre: "Aire acondicionado", icono: "aire-acondicionado", mensaje: "x1" },
            { nombre: "Calefacción", icono: "calefaccion", mensaje: "2 caloventores" },
            { nombre: "Baños", icono: "baño", mensaje:"x1" },
            { nombre: "Cocina", icono: "cocina", mensaje:"x1" },
            { nombre: "Lavarropas", icono: "lavarropas", mensaje:"NO" },
            { nombre: "Secador Pelo", icono: "secador-pelo", mensaje:"NO" },
            { nombre: "Frazadas", icono: "frazadas", mensaje:"Si" },
            { nombre: "Ropa Blanca", icono: "ropadecama", mensaje:"NO" },
            { nombre: "Pet Friendly", icono: "pets", mensaje:"Si" },
            { nombre: "Cochera", icono: "cochera", mensaje:"x1" }
        ],
        dormitorios: [
            { nombre: "Individuales", icono: "cama1", mensaje: "x2" },
            { nombre: "Dobles", icono: "cama-doble", mensaje: "x1" },
            { nombre: "King Size", icono: "cama-king-size", mensaje:"No" },
            { nombre: "Cuna", icono: "cuna", mensaje:"x2" }
        ],
        instalaciones: [
            { nombre: "Pileta", icono: "pileta", mensaje: "x1" },
            { nombre: "Terraza", icono: "baño", mensaje: "x1" },
            { nombre: "Jardín", icono: "cochera", mensaje:"x2" },
            { nombre: "Asador", icono: "parrilla", mensaje:"x2" },
            { nombre: "Gimnasio", icono: "gym", mensaje:"x2" },
            { nombre: "Ascensor", icono: "ascensor", mensaje:"x2" },
            { nombre: "Vista Panoramica", icono: "vista-panoramica", mensaje:"x2" }
        ]

 */